const PYRAMID_X_OFFSET = 0.32;
const PYRAMID_Y_OFFSET = 0.68;
const TOP_LEVEL_METRIC_X_OFFSET = 3.75;

export const applyPyramidXOffset = (index: number) => PYRAMID_X_OFFSET * index;
export const applyPyramidYOffset = (index: number) => PYRAMID_Y_OFFSET * index;
export const applyTopLevelMetricXOffset = (index: number) =>
  TOP_LEVEL_METRIC_X_OFFSET * index;
